// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__bAytf","loader":"Loader_loader__05Vlv","rotation":"Loader_rotation__3M1k8"};